import React, { useState, useEffect } from 'react';
import PageContainer from '../components/layout/PageContainer';

// Import section components
import HeroSection from '../components/about/HeroSection';
import CompanyOverview from '../components/about/CompanyOverview';
import IndustryLandscape from '../components/about/IndustryLandscape';
import StatsSection from '../components/about/StatsSection';
import TechnologySection from '../components/about/TechnologySection';
import LeadershipSection from '../components/about/LeadershipSection';
import FutureSection from '../components/about/FutureSection';
import CtaSection from '../components/about/CtaSection';
import CompanyLocations from '../components/about/CompanyLocations';

const About = () => {
    // Growth stats animation
    const [animateStats, setAnimateStats] = useState(false);

    useEffect(() => {
        const statsSection = document.getElementById('stats-section');
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setAnimateStats(true);
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.3 });

        if (statsSection) {
            observer.observe(statsSection);
        }

        return () => {
            if (statsSection) {
                observer.unobserve(statsSection);
            }
        };
    }, []);

    return (
        <PageContainer style={{ maxWidth: '100vw', overflowX: 'hidden' }}>
            <HeroSection />
            <CompanyOverview />
            <IndustryLandscape />
            <StatsSection animateStats={animateStats} />
            <TechnologySection />
            <LeadershipSection />
            <FutureSection />
            <CompanyLocations />
            <CtaSection />
        </PageContainer>
    );
};

export default About;